import { constants } from "@newsela/angelou";

const { colors } = constants;
const neutral25 = colors.ui.neutral[25];
const neutral700 = colors.ui.neutral[700];

export const promptContainerCss = {
  background: neutral25,
  borderRadius: "8px",
  color: neutral700,
  lineHeight: "1.375rem",
  whiteSpace: "break-spaces",
  padding: 16,
  wordBreak: "break-word",
};
